import React from 'react';
import './index.scss';
import { Paper, Tabs, Tab} from '@material-ui/core';

import { Line} from "react-chartjs-2";
import "chartjs-plugin-annotation";
import { inject } from 'mobx-react';

import {CircularProgress} from '@material-ui/core';

import moment from 'moment';

//api
import {api} from '../../../functions/api';

// const options = {
//     annotation: {
//          annotations: [{
//              drawTime: 'afterDatasetsDraw',
//              borderColor: 'red',
//              borderDash: [2, 2],
//              borderWidth: 2,
//              mode: 'vertical',
//              type: 'line',
//              value: 10,
//              scaleID: 'x-axis-0',
//        }]
//     },
//     maintainAspectRation: false
// };



@inject("translate")
@inject('internal')
export default class Graph extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            value: 0,
            loading: false,
        };
    }
    
    componentDidMount() {
        this.loadDashboardChart();
    }

    handleChange = (event, value) => {
        this.setState({ value:value });
    };

    options = (props) => {
        let stepSize = 1
        if(props.length > 10 ) {
            // let maxVal = props.filter(item => item.y)
            let maxVal = Math.max.apply(Math, props.map(function(o) { return o.y; }))
            stepSize = maxVal / 10;
        }
        return (
            {
                scales: {
                    xAxes: [{
                        gridLines: {
                            drawOnChartArea: false
                        }
                    }],
                    yAxes: [{
                        display: true,
                        ticks: {
                            min: 0,
                            stepSize: stepSize
                        }
                    }]
                },
                legend: {
                    display: false
                },
                tooltips: {
                    backgroundColor:'rgba(0, 0, 0, 0.54)',
                    titleMarginBottom: 16,
                    xPadding: 16,
                    yPadding: 16
                }
            })
        }

    data2 = {
        labels: [ ],
        datasets: [
        {
            
            //fill: false,
            lineTension: 0.1,
            backgroundColor: 'rgba(51,102,204,.3)',
            borderColor: 'rgba(51,102,204,1)',
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: 'rgba(51,102,204,1)',
            pointBackgroundColor: '#fff',
            pointBorderWidth: 1,
            pointHoverRadius: 4,
            pointHoverBackgroundColor: 'rgba(51,102,204,1)',
            pointHoverBorderColor: 'rgba(51,102,204,1)',
            pointHoverBorderWidth: 2,
            pointRadius: 3,
            pointHitRadius: 10,
            // data: [65, 59, 80, 81, 56, 55, 40],
            data: []
          }
        ],
    };

    data3 = {
        labels: [ ],
        datasets: [
        {
            
            //fill: false,
            lineTension: 0.1,
            backgroundColor: 'rgba(51,102,204,.3)',
            borderColor: 'rgba(51,102,204,1)',
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: 'rgba(51,102,204,1)',
            pointBackgroundColor: '#fff',
            pointBorderWidth: 1,
            pointHoverRadius: 4,
            pointHoverBackgroundColor: 'rgba(51,102,204,1)',
            pointHoverBorderColor: 'rgba(51,102,204,1)',
            pointHoverBorderWidth: 2,
            pointRadius: 3,
            pointHitRadius: 10,
            // data: [65, 59, 80, 81, 56, 55, 40],
            data: []
          }
        ],
    };

    data4 = {
        labels: [ ],
        datasets: [
        {
            
            //fill: false,
            lineTension: 0.1,
            backgroundColor: 'rgba(51,102,204,.3)',
            borderColor: 'rgba(51,102,204,1)',
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: 'rgba(51,102,204,1)',
            pointBackgroundColor: '#fff',
            pointBorderWidth: 1,
            pointHoverRadius: 4,
            pointHoverBackgroundColor: 'rgba(51,102,204,1)',
            pointHoverBorderColor: 'rgba(51,102,204,1)',
            pointHoverBorderWidth: 2,
            pointRadius: 3,
            pointHitRadius: 10,
            // data: [65, 59, 80, 81, 56, 55, 40],
            data: []
          }
        ],
    };
    
    data_year = []
    data_month = []
    data_week = []
    labels = []
    labels_month = []
    labels_week = []

    loadDashboardChart = async() => {
        this.setState({loading: true})
        let load_data_month = await api({
            method: 'get',
            url: 'dashboard/chart?period=month',
            authorization: this.props.internal.user.access_token,
        })

        let load_data_week = await api({
            method: 'get',
            url: 'dashboard/chart?period=week',
            authorization: this.props.internal.user.access_token,
        })

        let load_data_year = await api({
            method: 'get',
            url: 'dashboard/chart?period=year',
            authorization: this.props.internal.user.access_token,
        })
    
        if(load_data_year.success === true) {
            
            let j = 0;
            for(let i = 1; i<= load_data_year.data.data.chart.length; i++) {
                let month = this.props.translate.i18n.GLOBAL.MONTHS[moment(load_data_year.data.data.chart[j].period.start).month() + 1]
                this.labels.push(month)
                this.data_year.push({y:Number(load_data_year.data.data.chart[i-1].orders_count), x: i-1})
                j++

            }

            this.data2.datasets[0].data = this.data_year;
            this.data2.labels = this.labels;
        }

        if(load_data_month.success === true) {
            for(let i=0; i<load_data_month.data.data.chart.length; i++) {
                let day = moment(load_data_month.data.data.chart[i].period.start).format("DD.MM")
                this.data_month.push(Number(load_data_month.data.data.chart[i].orders_count))
                this.labels_month.push(day)
            }
            this.data3.datasets[0].data = this.data_month;
            this.data3.labels = this.labels_month;
        }

        if(load_data_week.success === true) {
            for(let i=0; i<load_data_week.data.data.chart.length; i++) {
                // let day  = dateformat(load_data_week.data.data.chart[i].period.start, "dd.mm.yyyy");
                let day = moment(load_data_week.data.data.chart[i].period.start).format("DD.MM")
                this.data_week.push(Number(load_data_week.data.data.chart[i].orders_count))
                this.labels_week.push(day)
            }
            this.data4.datasets[0].data = this.data_week;
            this.data4.labels = this.labels_week;
            
        }
        this.setState({loading: false})
    }

    render() {
        return (
            <Paper className={'graph-box'}>

            {this.state.loading ?
                <CircularProgress className = {'circular-progress-graph'}/>
            :
            <div>
                <Tabs
                    value={this.state.value}
                    onChange={this.handleChange}
                    className={'list-tabs'}
                    classes={{
                        indicator: "orangeIndicator"
                    }}
                >
                    <Tab label={this.props.translate.i18n.MODULES.DASHBOARD.YEAR} className={'tab'}/>
                    <Tab label={this.props.translate.i18n.MODULES.DASHBOARD.MONTH} className={'tab'}/>
                    <Tab label={this.props.translate.i18n.MODULES.DASHBOARD.WEEK} className={'tab'}/>
                </Tabs>
                {this.state.value === 0 &&
                
                <div className={'graph'}>
                    <Line
                        data={this.data2}
                        options={this.options(this.data2.datasets[0].data)}
                    />
                </div>
                }
                {this.state.value === 1 &&

                <div className={'graph'}>
                    <Line
                        data={this.data3}
                        options={this.options(this.data3.datasets[0].data)}
                    />
                </div>
                }
                {this.state.value === 2 &&
                
                <div className={'graph'}>
                    <Line
                        data={this.data4}
                        options={this.options(this.data4.datasets[0].data)}
                    />
                </div>
                }
                </div>
            }
            </Paper>
        );
    }
}





// WEBPACK FOOTER //
// ./src/components/complex/graph/index.js